// Lightweight GA4 wiring. No-ops until REACT_APP_GA_ID is set (add it when going live).
import { browserId } from "./attribution";
const GA_ID = process.env.REACT_APP_GA_ID;

export function initAnalytics() {
  if (!GA_ID || typeof window === "undefined" || window.__gaInit) return;
  window.__gaInit = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageview(path) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", name, params);
}

// One GA4 purchase per Stripe-confirmed session: the server hands out the event exactly once.
export async function claimPurchase(api, sessionId) {
  if (!sessionId) return;
  try {
    const { data } = await api.post("/analytics/purchase-claim", { session_id: sessionId, bid: browserId() });
    if (data.fire) trackEvent("purchase", { transaction_id: data.transaction_id, currency: data.currency, value: data.value, items: [{ item_id: data.item_id }] });
  } catch { /* analytics must never break the page */ }
}

// Fire an event through the existing analytics stack: GA4 (when REACT_APP_GA_ID is set)
// AND PostHog (already active in index.html). Used for ChalkOS integration events.
export function trackChalkos(name, params = {}) {
  trackEvent(name, params);
  try {
    if (typeof window !== "undefined" && window.posthog && window.posthog.capture) {
      window.posthog.capture(name, params);
    }
  } catch (e) {
    /* no-op */
  }
}
